import { createGlobalStyle } from 'styled-components';
import { theme } from './theme';

const GlobalStyle = createGlobalStyle`

  @supports(padding:max(0px)) {
      body, header, footer {
          padding-left: min(0vmin, env(safe-area-inset-left));
          padding-right: min(0vmin, env(safe-area-inset-right));
          padding-bottom: min(0vmin, env(safe-area-inset-bottom));
      }
  }


  :root {
    --colors-primary: #fee372;
    --colors-primaryLight: #ffeb85;
    --colors-primaryDark: #ffd30d;
    --colors-primaryContrast: #114a8c;
    --colors-white: #FFFFFF;
    --colors-black: black;
    --colors-tertiary: #f0b041;
    --colors-tertiaryDark: #d48d11;
    --colors-danger: #e80000;
    --colors-periwinkleGray: #E9EBF7;
    --colors-snow: #f5f8fc;
    --colors-geyser: #dee2e6;
    --colors-slate: #383b40;
    --colors-charcoal: #22262a;
    --colors-onyx: #3F3F3F;
    --colors-jet: #282828;
    --colors-success: #00C851;
    --colors-warning: #ffbb33;
    --colors-error: #ff4444;
    --colors-beige: #faf9f6;
    --colors-sky: #f2f8ff;
    --nav-height: 70px;
    --font-family-heading: 'Roboto', -apple-system, BlinkMacSystemFont, sans-serif;
    --font-family-body: 'Roboto', -apple-system, BlinkMacSystemFont, sans-serif;
    background-color: white;
    margin: 0;
    font-family: 'Roboto', -apple-system, BlinkMacSystemFont, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: ${theme.colors.text.primary};
  }

  html {

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }


  body {
    margin: 0;
    padding: 0;
  }

  * {
    box-sizing: border-box;
  }

  *,
  *::before,
  *::after {
    border-width: 0;
    border-style: solid;
    box-sizing: border-box;
  }


  button,
  input {
    overflow: visible;
  }

  button,
  select {
    text-transform: none;
  }

  button,
  a[href],
  [role="button"] {
    cursor: pointer;
  }

  textarea,
  input[type='text'],
  input[type='email'], 
  a[type="button"], 
  select {
    -webkit-appearance: none;
  }

  .no-scroll {
    overflow: hidden;
    position: fixed;
  }

  #__next {
    position: relative;
  }

  /*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */

  /* Document
	========================================================================== */

  /**
	* 1. Correct the line height in all browsers.
	* 2. Prevent adjustments of font size after orientation changes in iOS.
	*/

  html {
    line-height: 1.25;
    font-size: 16px; /* Base Font Size */
    -webkit-text-size-adjust: 100%; /* 2 */

    @media (max-width: ${theme.breakpoints.md}) {
      font-size: 16px;

      /* Safari resize fix */
      min-height: 0vw;
    }

    /*** Styles added to fix the issue with zoom in on iphone ***/
    /* iPhone < 5: */
    @media screen and (device-aspect-ratio: 2/3) {
        select, textarea, input[type="text"], input[type="password"],
        input[type="datetime"], input[type="datetime-local"],
        input[type="date"], input[type="month"], input[type="time"],
        input[type="week"], input[type="number"], input[type="email"],
        input[type="url"]{ font-size: 16px; }
    }

    /* iPhone 5, 5C, 5S, iPod Touch 5g */
    @media screen and (device-aspect-ratio: 40/71) {
        select, textarea, input[type="text"], input[type="password"],
        input[type="datetime"], input[type="datetime-local"],
        input[type="date"], input[type="month"], input[type="time"],
        input[type="week"], input[type="number"], input[type="email"],
        input[type="url"]{ font-size: 16px; }
    }

    /* iPhone 6, iPhone 6s, iPhone 7 portrait/landscape */
    @media screen and (device-aspect-ratio: 375/667) {
        select, textarea, input[type="text"], input[type="password"],
        input[type="datetime"], input[type="datetime-local"],
        input[type="date"], input[type="month"], input[type="time"],
        input[type="week"], input[type="number"], input[type="email"],
        input[type="url"]{ font-size: 16px; }
    }

    /* iPhone 6 Plus, iPhone 6s Plus, iPhone 7 Plus portrait/landscape */
    @media screen and (device-aspect-ratio: 9/16) {
        select, textarea, input[type="text"], input[type="password"],
        input[type="datetime"], input[type="datetime-local"],
        input[type="date"], input[type="month"], input[type="time"],
        input[type="week"], input[type="number"], input[type="email"],
        input[type="url"]{ font-size: 16px; }
    }
  }

  /* Sections
	========================================================================== */

  /**
	* Render the 'main' element consistently in IE.
	*/

  main {
    display: block;
  }

  h1, h2, h3, h4, h5, h6, p {
    letter-spacing: 0;
    margin-top: 0;
  }

  h1 {
    font-family: ${theme.fontFamily.heading};
    font-weight: ${theme.fontWeight.bold};
    font-size: 2.5rem;
    margin-bottom: 1.75rem;
  }

  h2 {
    font-family: ${theme.fontFamily.heading};
    font-weight: ${theme.fontWeight.bold};
    font-size: 2.25rem;
    margin-bottom: 1.5rem;
  }

  h3 {
    font-family: ${theme.fontFamily.heading};
    font-weight: ${theme.fontWeight.bold};
    font-size: 2rem;
    margin-bottom: 1.25rem;
  }

  h4 {
    font-family: ${theme.fontFamily.heading};
    font-weight: ${theme.fontWeight.bold};
    font-size: 1.75rem;
    margin-bottom: 1rem;
  }

  h5 {
    font-family: ${theme.fontFamily.heading};
    font-weight: ${theme.fontWeight.medium};
    font-size: 1.5em;
    margin-bottom: 0.75rem;
  }

  h6 {
    font-family: ${theme.fontFamily.heading};
    font-weight: ${theme.fontWeight.medium};
    font-size: 1.25rem;
    margin-bottom: 0.5rem;
  }

  p {
    font-family: ${theme.fontFamily.body};
    font-weight: ${theme.fontWeight.regular};
    font-size: 18px;
    margin-bottom: 1rem;
  }

  li {
    margin-bottom: 1rem;
  }

  /* Grouping content
	========================================================================== */

  /**
	* 1. Add the correct box sizing in Firefox.
	* 2. Show the overflow in Edge and IE.
	*/

  hr {
    box-sizing: content-box; /* 1 */
    height: 0; /* 1 */
    overflow: visible; /* 2 */
  }

  /**
	* 1. Correct the inheritance and scaling of font size in all browsers.
	* 2. Correct the odd 'em' font sizing in all browsers.
	*/

  pre {
    font-family: monospace, monospace; /* 1 */
    font-size: 1em; /* 2 */
  }

  /* Text-level semantics
	========================================================================== */

  /**
	* Remove the gray background on active links in IE 10.
	*/

  a {
    background-color: transparent;
    text-decoration: none;
    color: inherit;
  }

  /**
	* 1. Remove the bottom border in Chrome 57-
	* 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
	*/

  abbr[title] {
    border-bottom: none; /* 1 */
    text-decoration: underline; /* 2 */
    text-decoration: underline dotted; /* 2 */
  }

  /**
	* Add the correct font weight in Chrome, Edge, and Safari.
	*/

  b,
  strong {
    font-weight: bolder;
  }

  /**
	* 1. Correct the inheritance and scaling of font size in all browsers.
	* 2. Correct the odd 'em' font sizing in all browsers.
	*/

  code,
  kbd,
  samp {
    font-family: monospace, monospace; /* 1 */
    font-size: 1em; /* 2 */
  }

  /**
	* Add the correct font size in all browsers.
	*/

  small {
    font-size: 80%;
  }

  /**
	* Prevent 'sub' and 'sup' elements from affecting the line height in
	* all browsers.
	*/

  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }

  sub {
    bottom: -0.25em;
  }

  sup {
    top: -0.5em;
  }

  /* Embedded content
	========================================================================== */

  /**
	* Remove the border on images inside links in IE 10.
	*/

  img {
    border-style: none;
  }

  /* Forms
	========================================================================== */

  /**
	* 1. Change the font styles in all browsers.
	* 2. Remove the margin in Firefox and Safari.
	*/

  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit; /* 1 */
    font-size: 100%; /* 1 */
    line-height: 1.15; /* 1 */
  }

  /**
	* Show the overflow in IE.
	* 1. Show the overflow in Edge.
	*/

  button,
  input {
    /* 1 */
    overflow: visible;
  }

  /**
	* Remove the inheritance of text transform in Edge, Firefox, and IE.
	* 1. Remove the inheritance of text transform in Firefox.
	*/

  button,
  select {
    /* 1 */
    text-transform: none;
  }

  /**
	* Correct the inability to style clickable types in iOS and Safari.
	*/

  button,
  [type='button'],
  [type='reset'],
  [type='submit'] {
    -webkit-appearance: button;
  }

  /**
	* Remove the inner border and padding in Firefox.
	*/

  button::-moz-focus-inner,
  [type='button']::-moz-focus-inner,
  [type='reset']::-moz-focus-inner,
  [type='submit']::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }

  /**
	* Restore the focus styles unset by the previous rule.
	*/

  button:-moz-focusring,
  [type='button']:-moz-focusring,
  [type='reset']:-moz-focusring,
  [type='submit']:-moz-focusring {
    outline: 1px dotted ButtonText;
  }

  /**
	* Correct the padding in Firefox.
	*/

  fieldset {
    padding: 0.35em 0.75em 0.625em;
  }

  /**
	* 1. Correct the text wrapping in Edge and IE.
	* 2. Correct the color inheritance from 'fieldset' elements in IE.
	* 3. Remove the padding so developers are not caught out when they zero out
	*    'fieldset' elements in all browsers.
	*/

  legend {
    box-sizing: border-box; /* 1 */
    color: inherit; /* 2 */
    display: table; /* 1 */
    max-width: 100%; /* 1 */
    padding: 0; /* 3 */
    white-space: normal; /* 1 */
  }

  /**
	* Add the correct vertical alignment in Chrome, Firefox, and Opera.
	*/

  progress {
    vertical-align: baseline;
  }

  /**
	* Remove the default vertical scrollbar in IE 10+.
	*/

  textarea {
    overflow: auto;
  }

  /**
	* 1. Add the correct box sizing in IE 10.
	* 2. Remove the padding in IE 10.
	*/

  [type='checkbox'],
  [type='radio'] {
    box-sizing: border-box; /* 1 */
    padding: 0; /* 2 */
  }

  /**
	* Correct the cursor style of increment and decrement buttons in Chrome.
	*/

  [type='number']::-webkit-inner-spin-button,
  [type='number']::-webkit-outer-spin-button {
    height: auto;
  }

  /**
	* 1. Correct the odd appearance in Chrome and Safari.
	* 2. Correct the outline style in Safari.
	*/

  [type='search'] {
    -webkit-appearance: textfield; /* 1 */
    outline-offset: -2px; /* 2 */
  }

  /**
	* Remove the inner padding in Chrome and Safari on macOS.
	*/

  [type='search']::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  /**
	* 1. Correct the inability to style clickable types in iOS and Safari.
	* 2. Change font properties to 'inherit' in Safari.
	*/

  ::-webkit-file-upload-button {
    -webkit-appearance: button; /* 1 */
    font: inherit; /* 2 */
  }

  /* Interactive
	========================================================================== */

  /*
	* Add the correct display in Edge, IE 10+, and Firefox.
	*/

  details {
    display: block;
  }

  /*
	* Add the correct display in all browsers.
	*/

  summary {
    display: list-item;
  }

  /* Misc
	========================================================================== */

  /**
	* Add the correct display in IE 10+.
	*/

  template {
    display: none;
  }

  /**
	* Add the correct display in IE 10.
	*/

  [hidden] {
    display: none;
  }
}
`;

export default GlobalStyle;
